import { create } from "zustand";

const TOKEN_KEY = "balaji_token";

// sessionStorage (not localStorage) is intentional: it's scoped to a single
// browser tab and is cleared when that tab/window closes. localStorage is
// shared across every tab of the browser and survives restarts, which meant
// a copy-pasted admin link opened in a new tab (or the browser reopened
// later) would silently reuse an old login instead of asking to re-auth.
export const useAuth = create((set) => ({
  token: typeof window !== "undefined" ? sessionStorage.getItem(TOKEN_KEY) : null,
  user: null,
  setAuth: (token, user) => {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    set({ token, user });
  },
  logout: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    set({ token: null, user: null });
  },
}));